<div class="date-range-picker">
  <!-- <label [style]="'width:' + labelWidth + 'px'" *ngIf="label">{{
    label
  }}</label> -->

  <!-- Start Date Input -->
  <mat-form-field class="date-field">
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      [matDatepicker]="pickerLower"
      [(ngModel)]="lowerRange"
      (dateChange)="onLowerRangeChanged()"
      [required]="required"
      [disabled]="disabled"
      name="lowerRange{{ myId }}"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="pickerLower"
    ></mat-datepicker-toggle>
    <mat-datepicker #pickerLower></mat-datepicker>
    <mat-hint>{{ startDateLabelText }}</mat-hint>
  </mat-form-field>

  <!-- End Date Input -->
  <mat-form-field class="padded-left date-field">
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      [matDatepicker]="pickerUpper"
      [(ngModel)]="upperRange"
      (dateChange)="onUpperRangeChanged()"
      [required]="required"
      [disabled]="disabled"
      name="upperRange{{ myId }}"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="pickerUpper"
    ></mat-datepicker-toggle>
    <mat-datepicker #pickerUpper></mat-datepicker>
    <mat-hint>{{ endDateLabelText }}</mat-hint>
  </mat-form-field>

  <!-- Quick Select Button -->
  <button
    type="button"
    mat-icon-button
    [matMenuTriggerFor]="menu"
    *ngIf="!hideQuickSelect"
  >
    <mat-icon>more_vert</mat-icon>
  </button>

  <!-- Main Quick Select Menu -->
  <mat-menu #menu="matMenu">
    <button type="button" mat-menu-item [matMenuTriggerFor]="currentRanges">
      Current
    </button>
    <button type="button" mat-menu-item [matMenuTriggerFor]="pastRanges">
      Past
    </button>
    <button type="button" mat-menu-item [matMenuTriggerFor]="nextRanges">
      Next
    </button>
    <mat-divider></mat-divider>
    <button type="button" mat-menu-item (click)="clearDateRange()">
      Clear
    </button>
  </mat-menu>

  <!-- Hardcoded Current Date Ranges -->
  <mat-menu #currentRanges="matMenu" (menuClosed)="onMenuClosed()">
    <button type="button" mat-menu-item (click)="onDateRangeSelected('today')">
      Today
    </button>
    <button
      type="button"
      mat-menu-item
      (click)="onDateRangeSelected('thisWeek')"
    >
      This Week
    </button>
    <button
      type="button"
      mat-menu-item
      (click)="onDateRangeSelected('thisMonth')"
    >
      This Month
    </button>
    <button
      type="button"
      mat-menu-item
      (click)="onDateRangeSelected('thisYear')"
    >
      This Year
    </button>
  </mat-menu>

  <!-- Hardcoded Past Date Ranges -->
  <mat-menu #pastRanges="matMenu" (menuClosed)="onMenuClosed()">
    <button
      type="button"
      mat-menu-item
      (click)="onDateRangeSelected('yesterday')"
    >
      Yesterday
    </button>
    <button
      type="button"
      mat-menu-item
      (click)="onDateRangeSelected('lastWeek')"
    >
      Last Week
    </button>
    <button
      type="button"
      mat-menu-item
      (click)="onDateRangeSelected('lastMonth')"
    >
      Last Month
    </button>
    <button
      type="button"
      mat-menu-item
      (click)="onDateRangeSelected('lastYear')"
    >
      Last Year
    </button>
    <mat-divider></mat-divider>
    <button type="button" mat-menu-item (click)="onDateRangeSelected('past7')">
      Past 7 Days
    </button>
    <button type="button" mat-menu-item (click)="onDateRangeSelected('past30')">
      Past 30 Days
    </button>
  </mat-menu>

  <!-- Hardcoded Next Date Ranges -->
  <mat-menu #nextRanges="matMenu" (menuClosed)="onMenuClosed()">
    <button
      type="button"
      mat-menu-item
      (click)="onDateRangeSelected('tomorrow')"
    >
      Tomorrow
    </button>
    <button
      type="button"
      mat-menu-item
      (click)="onDateRangeSelected('nextWeek')"
    >
      Next Week
    </button>
    <button
      type="button"
      mat-menu-item
      (click)="onDateRangeSelected('nextMonth')"
    >
      Next Month
    </button>
    <button
      type="button"
      mat-menu-item
      (click)="onDateRangeSelected('nextYear')"
    >
      Next Year
    </button>
    <mat-divider></mat-divider>
    <button type="button" mat-menu-item (click)="onDateRangeSelected('next7')">
      Next 7 Days
    </button>
    <button type="button" mat-menu-item (click)="onDateRangeSelected('next30')">
      Next 30 Days
    </button>
  </mat-menu>
</div>
